export default "__VITE_ASSET__1b6361c4__"